export const blockIconsNavigationWest = (
	<span className='material-symbols-outlined'>west</span>
);
